import { CobranzasService } from './../../../../services/cobranzas/cobranzas.service';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-detalle-reprogramacion',
  templateUrl: './detalle-reprogramacion.component.html',
  styleUrls: ['./detalle-reprogramacion.component.scss']
})
export class DetalleReprogramacionComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  @Output() cerrarPopUp : EventEmitter<boolean> = new EventEmitter();
  form : FormGroup;
  idCobranza_Reprogramada:any;
  data:any;


  constructor(private cobranzaService : CobranzasService ) {
    this.data = cobranzaService.dataDetalleReprogramacion;
    this.idCobranza_Reprogramada = this.data.idCobranza_Reprogramada;
   }

  ngOnInit() {
    this.form = new FormGroup({
      idComprobante : new FormControl({ value: "", disabled: true }),
      Nombre_Comercial : new FormControl({ value: "", disabled: true }),
      Moneda : new FormControl({ value: "", disabled: true }),
      VNPP : new FormControl({ value: "", disabled: true }),
      Monto_Negociado : new FormControl({ value: "", disabled: true }),
      Cuotas : new FormControl({ value: "", disabled: true }),
      Monto_Cobrado : new FormControl({ value: "", disabled: true }),
      Fecha_Registro : new FormControl({ value: "", disabled: true }),
      Observacion : new FormControl({ value: "", disabled: true }),
    })

    this.form.controls['idComprobante'].setValue(this.data.idComprobante);
    this.form.controls['Nombre_Comercial'].setValue(this.data.Nombre_Comercial);
    this.form.controls['Moneda'].setValue(this.data.Moneda);
    this.form.controls['VNPP'].setValue(this.data.VNPP);
    this.form.controls['Monto_Negociado'].setValue(this.data.Monto_Negociado);
    this.form.controls['Cuotas'].setValue(this.data.Cuotas);
    this.form.controls['Monto_Cobrado'].setValue(this.data.Monto_Cobrado);
    this.form.controls['Fecha_Registro'].setValue(this.data.Fecha_Registro);
    this.form.controls['Observacion'].setValue(this.data.Observacion);
  }

  CerrarPopUp(){
    this.cerrarPopUp.emit();
  }

}
